'use strict';

var RelayRecordState = {
  EXISTENT: 'EXISTENT',
  NONEXISTENT: 'NONEXISTENT',
  UNKNOWN: 'UNKNOWN'
};
module.exports = RelayRecordState;